import { Injectable } from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { CreateSalesOrderModalComponent } from "./create-sales-order.component";

@Injectable()
export class CreateSalesOrderService {
  constructor(private dialogService: NbDialogService) {}

  createSalesOrderModal(_salesOrderUUID: number) {
    const modal = this.dialogService.open(CreateSalesOrderModalComponent, {
      context: {
        salesOrderUUID: _salesOrderUUID,
      },
    });

    return new Promise((resolve, reject) => {
      modal.onClose.subscribe((result) => {
        resolve(result);
      });
    });
  }
}
